import React, { useContext, useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { AuthContext } from "../context/AuthContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export default function Login() {
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target[0].value;
    const password = e.target[1].value;

    //FIREBASE
    await signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in 
        navigate("/");
        const user = userCredential.user;
      })
      .catch((error) => {
        const errorMessage = error.code.split("/")[1];
        setError(errorMessage);
      })
  }
  useEffect(() => {
    if (currentUser) {
      navigate("/");
    }
  }, [currentUser]);
  return (
    <div className="formContainer">
      <div className="formWrapper">
        <span className="logo">Chatmore</span>
        <span className="title">Login</span>
        <form onSubmit={handleSubmit}>
          <input type="email" placeholder="email" />
          <div style={{display: 'flex', alignItems: 'center', gap:'2px'}}>
            <input onChange={(e) => setPassword(e.target.value)} type={showPassword ? "text" : "password"} placeholder="password" />
            <span style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
              {password && (showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />)}
            </span>
          </div>
          <button>Sign in</button>
        </form>
        {error && <span className="alert">{error}</span>}
        <p>
          Don't have an account? <Link to="/register">Register</Link>
        </p>
      </div>
    </div>
  );
}
